module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-costume-df7cc251c48fb7401538ca01dcb7d916.png";